export const API_JSON_EXAMPLE = `{
  "id": "4334549e-2d2f-4f20-b48a-d29d5f57497d",
  "timestamp": 1751027894,
  "recordings": [
    {
      "video_path": "<signed_url>",
      "thumbnail_path": "<signed_url>",
      "video_bbox_path": "<signed_url>",
      "video_predictions_path": "<signed_url>",
      "image_path": "<signed_url>",
      "image_predictions_path": "<signed_url>"
    }
  ],
  "machine_code_results": [
    {
      "machine_code_string": "<barcode_or_qrcode_result>",
      "machine_code_type_name": "<barcode_or_qrcode_type>",
      "machine_code_crop_path": "<signed_url>"
    }
  ],
  "ocr_results": [
    {
      "ocr_string": "<ocr_result>",
      "ocr_confidence": 0.95,
      "ocr_crop_path": "<signed_url>",
      "ocr_tag": "whitelist"
    },
    {
      "ocr_string": "<ocr_result>",
      "ocr_confidence": 0.85,
      "ocr_crop_path": "<signed_url>",
      "ocr_tag": null
    }
  ],
  "alert": false,
  "confidence": 0.85,
  "dwell_time": 9.29,
  "detections": "ROI->0->area1->license_plate",
  "output": {
    "stream": {
      "id": "6634ea4d-9389-4b45-9502-a7a7471a79b6",
      "business_logics": [
        {
          "ROI": {
            "area1": {
              "label_groups": [
                {
                  "type": "single",
                  "label_id": "license_plate",
                  "count_threshold": 1,
                  "confidence_threshold": 0.3,
                  "segmentation_threshold": null
                }
              ],
              "rule": "OR"
            }
          }
        }
      ]
    }
  }
}`
